/**
 * @generated SignedSource<<62983c6c71817a3cf691c4d78b162201>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ItemAssociationType = "group" | "item" | "mixed" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespPersonalizedItemsCarousel_viewer$data = {
  readonly personalizedItems?: {
    readonly associatedItems: ReadonlyArray<{
      readonly associationType: ItemAssociationType;
      readonly item: {
        readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_items">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_viewer">;
  readonly " $fragmentType": "PdpRespPersonalizedItemsCarousel_viewer";
};
export type PdpRespPersonalizedItemsCarousel_viewer$key = {
  readonly " $data"?: PdpRespPersonalizedItemsCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "personalizationModuleEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespPersonalizedItemsCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_viewer"
    },
    {
      "condition": "personalizationModuleEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "PersonalizedItems",
          "kind": "LinkedField",
          "name": "personalizedItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonalizedItem",
              "kind": "LinkedField",
              "name": "associatedItems",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "associationType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "item",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "userCountryCode",
                          "variableName": "userCountryCode"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "PdpRespProductTileCarousel_items"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a505b85bd36c493d8baaac9bf31116d7";

export default node;
